import json from './sprite.js';

export default {
    handle: 'SP_SPT12-ToyBox',
    label: 'es_SPT12-ToyBox_234684286',
    json,
};
